<template lang="pug">
  div(v-if="$store.state.vehicles.all.length > 0" @resized="onResized" :style="{'height':`${height-10}px`, 'background-color':'#CCCCCC'}" )
    splitpanes.default-theme()
      pane(:size="28" style="overflow-y:auto;")
        trip-side-bar(v-if="vehicle_id"  :items="vehicle_list")
      pane(:size="72")
        template(v-if="$store.state.trips.trip_data.length > 0")
          .d-flex.flex-column(ref="contentArea" )
            v-progress-linear(v-if="$store.state.trips.isLoading" :indeterminate="$store.state.trips.isLoading"  color="primary")
            trip-map(:height="height" :key="track_key")
        template(v-else)
          .fill-height()
            .d-flex.fill-width.justify-center.align-center.font-italic.mt-12.grey--text() no data  |  {{getFormattedDate()}}


</template>
<script>
import TripSideBar from "@/modules/maps/components/ui/SideBar/TripSideBar";
import Timeline from "@/modules/maps/components/ui/TopSection/Timeline";
import HistoryMap from "@/modules/maps/components/maps/HisotryMap";
import TripMap from "@/modules/maps/components/maps/TripMap";
// import moment from "moment";
import { Splitpanes, Pane } from 'splitpanes';
import 'splitpanes/dist/splitpanes.css'
import moment from "moment/moment";

export default {
  components: {
    TripSideBar,
    Timeline,
    HistoryMap,
    TripMap,
    Splitpanes,
    Pane
  },

  mounted() {
    this.vehicle_list = [];
    this.$store.getters["vehicles/devices/getActiveTrackerEnabledDevices"].forEach((item) => {
      this.vehicle_list.push(item.vehicle);
    })
    if (this.vehicle_list.length > 0 ){
      let mapSelectedVehicleId = localStorage.getItem("mapSelectedVehicleId");
      if(mapSelectedVehicleId == null){
        this.vehicle_id = this.vehicle_list[0].id;
        localStorage.setItem("mapSelectedVehicleId", this.vehicle_list[0].id);
        mapSelectedVehicleId = this.vehicle_id
      }else{
        this.vehicle_id = mapSelectedVehicleId;
      }



      this.$store.commit("vehicles/devices/setCurrentIndexByVehicleID", mapSelectedVehicleId);
      this.$store.commit("trips/setCurrentVehicleID", mapSelectedVehicleId);
      this.$store.commit("timeline/setCurrentVehicleID", mapSelectedVehicleId);
    }

  },

  data: () => ({
    height: null,
    width: null,
    track_key:1,
    vehicle_id:null,
    vehicle_list:[],
  }),

  created() {
    // stretch the elements to fill the height
    this.height = window.innerHeight - 100;
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
      // this.width = this.$refs.contentArea.getBoundingClientRect().width;
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },

  methods: {
    onResized:function(){
      this.track_key++;
    },
    onResize:function(){
      this.height = window.innerHeight - 100;
    },
    getFormattedDate:function(){
      return moment(this.$store.getters["trips/getDateRange"].start).format("ddd, Do MMM YYYY")
    }
  }
};
</script>
<style scoped lang="stylus">
#trackContiner {
  display: flex;
  background-color: #CCCCCC;
  height: 100%;
  width: 100%;
}

#sideBar {
  background-color: #E80000;
  width: 100%;
  height: 100%;
}

#mainBody {
  background-color: #00CC00;
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
}

#showHideSideBar {
  background-color: #CCCCFF;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
}

#showHideSideBar:hover {
  background-color: #CCCCCC;
}
</style>
